import type { InventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import axios from "axios";
import type { InventoryConfigUpdateKey } from "./interface";

const baseUrl = "/landing/nxlambda/inventoryConfigs/";

export const fetchInventoryConfigGet = ({
  queryKey
}: InventoryConfigUpdateKey): Promise<InventoryListingConfig> =>
  axios
    .get(
      `${baseUrl}getConfig/${queryKey[1].accountId}/${queryKey[1].inventoryId}`
    )
    .then(res => res.data);

export const fetchInventoryConfigsGet = (
  _queryKey: string[],
  accountId: string
): Promise<string[]> =>
  axios.get(`${baseUrl}getConfigs/${accountId}`).then(res => res.data);

export const fetchInventoryConfigCreate = (
  config: InventoryListingConfig
): Promise<string[]> =>
  axios.post(`${baseUrl}createConfig`, config).then(res => res.data);

export const fetchInventoryConfigUpdate = (
  config: InventoryListingConfig
): Promise<string[]> =>
  axios.post(`${baseUrl}updateConfig`, config).then(res => res.data);
// /listingconfigs/config
